export default __webpack_public_path__ + "static/aging-hands-3007d3dad124d2788910211e9e607bfe.jpg";